export const EASE = [0.22, 1, 0.36, 1];

// Frozen: shared by spread across every section — mutating it in place
// would silently change all of them.
export const reveal = Object.freeze({
  initial: Object.freeze({ opacity: 0, y: 40 }),
  whileInView: Object.freeze({ opacity: 1, y: 0 }),
  viewport: Object.freeze({ once: true, margin: "-60px" }),
  transition: Object.freeze({ duration: 0.7, ease: EASE }),
});
